// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___2rGGZ","inner":"inner___1kLd6","title":"title___1moI-","icon":"icon___336bj","flat":"flat___2Y80i"};